module.exports = __webpack_public_path__ + "img/star-fox.84aa081c.png";